import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import "../node_modules/video-react/dist/video-react.css";
import App from './App';
import createHistory from 'history/createBrowserHistory'
import { createStore, applyMiddleware } from 'redux'
import { ConnectedRouter as Router, routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import { Route } from 'react-router-dom'
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './reducers'
import { Provider } from 'react-redux';
import {ProjectData} from './content/projectdata'

const history = createHistory();
const rMiddleware = routerMiddleware(history);

let initialState = {
  projects: ProjectData,
  current: {},
  styles: {}
}

let store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(thunk, rMiddleware)));

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Route path='/' component={App} />
    </Router>
  </Provider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js